//import { queryClient } from "src/lib/react-query";
import { mvteHomeApi } from "./mvte-home";
import { queryOptions } from "@tanstack/react-query";

function getRoleGroupPermsQueryOptions(data: {params: {roleGuids: Array<string>}}) {
    return queryOptions({
        queryKey: [
            "ad-role-perms",
            {RoleGuids: data.params.roleGuids}
        ],
        queryFn: () => mvteHomeApi.getGroupRolePermissions(data),
        retry: false,
        staleTime: 0,
        gcTime: 0,
    });
}
const mvteHomeQueryOptions =
{
    getRoleGroupPermsQueryOptions,
}

const mvteHomeMutations = 
{

}

export
{
    mvteHomeQueryOptions,
    mvteHomeMutations
}